import {
  GET_COMPANY,
  INVITE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  GET_COMPANY_LIST_TO_SWITCH,
  API_RESPONSE_SUCCESS,
  UPDATE_LOADING_STATE,
  API_RESPONSE_ERROR,
  RESET_COMPANY_ERROR,
  UPDATE_STATUS_STATE,
} from "./actionType";

// Common success
export const companyApiResponseSuccess = (actionType, response) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, response },
});

// Common error
export const companyApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Common loading
export const companyUpdateLoadingState = (actionType, isLoading) => ({
  type: UPDATE_LOADING_STATE,
  payload: { actionType, isLoading },
});

// Common status
export const companyUpdateStatusState = (actionType, status) => ({
  type: UPDATE_STATUS_STATE,
  payload: { actionType, status },
});

// Common reset error
export const companyResetError = (actionType) => ({
  type: RESET_COMPANY_ERROR,
  payload: { actionType },
});

export const getCompany = (params) => ({
  type: GET_COMPANY,
  payload: params,
});

export const getCompanyListToSwitch = (params) => ({
  type: GET_COMPANY_LIST_TO_SWITCH,
  payload: params,
});

export const inviteCompany = (companyDetails) => ({
  type: INVITE_COMPANY,
  payload: { companyDetails },
});

export const updateCompany = (id, companyDetails) => {
  return {
    type: UPDATE_COMPANY,
    payload: { id, companyDetails },
  };
};

export const deleteCompany = (companyId) => ({
  type: DELETE_COMPANY,
  payload: { companyId },
});
